import { BudgetBys } from 'business/constants';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { BudgetProposalT, OperationT } from 'routes/BudgetModule/config/types';
import { RQAPICallWithData } from 'store/APIClient';

export const useGetOperations = (
    budgetProposal: BudgetProposalT,
    resourceSoftwareId: string,
): UseQueryResult<OperationT[]> => {
    const queryParams = new URLSearchParams();
    queryParams.append('exercice', budgetProposal.exercice.toString());
    queryParams.append('budget_name', budgetProposal.budgetName);

    if (budgetProposal.section)
        queryParams.append('section', budgetProposal.section);

    queryParams.append(
        budgetProposal.by === BudgetBys.GESTIONNAIRE
            ? 'gestionnaire'
            : 'org_chart_finance.tree',
        resourceSoftwareId,
    );

    return useQuery({
        queryKey: [budgetProposal.id],

        queryFn: async () => {
            const response = await RQAPICallWithData<OperationT>({
                endpoint: `budget/operation/lite?${queryParams}`,
                method: 'GET',
            });
            return response.content.data;
        },
    });
};
